<template>
    <div class="apprentice-simple-card">
        <h4>{{ $t('learning_path.overview_of_exercises') }}</h4>
        <p>
            {{
                $t(
                    'learning_path.here_are_the_assignments_you_selected_by_period_you_can_choose_an_assignment_per_period_below_by_clicking_on_the_fluff',
                )
            }}
        </p>
        <design-2021-apprentice-data-table
            class="lp-deadline-series-overview"
            :items="tableData"
            :fields="deadlineFields">
            <template v-slot:cell(assignment)="data"> </template>
            <template v-slot:cell(assignment)="data">
                <b-button
                    class="btn-add btn-add-assignment"
                    v-if="!data.item.assignment && Date.now() < data.item.deadline"
                    v-b-tooltip:hover
                    variant="primary-icon-only"
                    :title="$t('learning_path.choose_title')"
                    @click="openLpCategories(data.item.id)">
                </b-button>
                <span v-else>{{ data.item.assignment }}</span>
            </template>
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-remove btn-remove-lp-deadline"
                        v-if="data.item.signupRecordId && Date.now() < data.item.deadline"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeAssignment(data.item.signupRecordId, data.item.id)">
                    </b-button>
                </div>
            </template>
            <template v-slot:cell(backUpAssignment)="data">
                <span v-if="data.item.assignment">
                    <b-button
                        class="btn-add btn-add-assignment"
                        v-if="!data.item.backUpAssignment && Date.now() < data.item.deadline"
                        v-b-tooltip:hover
                        variant="primary-icon-only"
                        :title="$t('learning_path.choose_title')"
                        @click="openLpCategories(data.item.id)">
                    </b-button>
                    <span v-else>{{ data.item.backUpAssignment }}</span>
                </span>
            </template>
            <template v-slot:cell(backUpAction)="data">
                <div class="actions">
                    <b-button
                        class="btn-remove btn-remove-lp-deadline"
                        v-if="data.item.backUpAssignment && Date.now() < data.item.deadline"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeAssignment(data.item.backUpSignUpRecordId, data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table';

export default {
    name: 'design-2021-learning-path-overview-component',
    components: { Design2021ApprenticeDataTable },
    props: ['lpDeadlineSeriesIn'],
    data() {
        return {
            lpDeadlineSeries: this.lpDeadlineSeriesIn,
            lpDeadlines: this.lpDeadlineSeriesIn ? this.lpDeadlineSeriesIn.lp_deadlines : [],
            deadlineFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'assignment',
                    label: this.$t('learning_path.exercise'),
                },
                {
                    key: 'category',
                    label: this.$t('learning_path.work_field'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
                {
                    key: 'backUpAssignment',
                    label: this.$t('learning_path.backup_assignment'),
                },
                {
                    key: 'backUpCategory',
                    label: this.$t('learning_path.work_field'),
                },
                {
                    key: 'backUpAction',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    computed: {
        tableData() {
            if (this.lpDeadlineSeriesIn) {
                const data = this.lpDeadlines.map((deadline) => {
                    const newDate = new Date(deadline.deadline);
                    return {
                        id: deadline.id,
                        name: deadline.name,
                        deadline: Date.parse(deadline.deadline),
                        assignment: deadline.lp_signup_records[0]
                            ? deadline.lp_signup_records[0].lp_assignment.name
                            : null,
                        category: deadline.lp_signup_records[0]
                            ? deadline.lp_signup_records[0].lp_assignment.lp_category.name
                            : null,
                        signupRecordId: deadline.lp_signup_records[0] ? deadline.lp_signup_records[0].id : null,
                        backUpAssignment: deadline.lp_signup_records[1]
                            ? deadline.lp_signup_records[1].lp_assignment.name
                            : null,
                        backUpCategory: deadline.lp_signup_records[1]
                            ? deadline.lp_signup_records[1].lp_assignment.lp_category.name
                            : null,
                        backUpSignUpRecordId: deadline.lp_signup_records[1] ? deadline.lp_signup_records[1].id : null,

                        dateObject: newDate,
                    };
                });
                return data.sort((objA, objB) => Number(objA.dateObject) - Number(objB.dateObject));
            } else {
                return null;
            }
        },
    },
    methods: {
        openLpCategories(id) {
            window.location.href = this.routes.lpDeadline(id);
        },
        removeAssignment(signupRecordId, deadlineId) {
            this.alert
                .confirm(
                    this.$t('learning_path.delete_exercise'),
                    this.$t('learning_path.are_you_sure_you_want_to_delete_this_exercise'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.lpRemoveSignupRecord(signupRecordId)).then(
                        (response) => {
                            this.lpDeadlines = this.lpDeadlines.map((deadline) => {
                                if (deadline.id === deadlineId) {
                                    const recordIdIndex = deadline.lp_signup_records.findIndex(
                                        (record) => record.id === signupRecordId,
                                    );
                                    if (recordIdIndex > -1) {
                                        deadline.lp_signup_records.splice(recordIdIndex, 1);
                                    }
                                    return deadline;
                                }
                                return deadline;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped></style>
